import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';


import 'react-datepicker/dist/react-datepicker.css';

export const FollowUpDateQuestion = ({ question, disabled, onAnswerChange }) => {
  const rdn = Math.random();

  const [value, setValue] = useState(question.answer.value ? moment(question.answer.value).toDate() : null);
  const [checked, setChecked] = useState(question.answer.checked);

  return (
    <div className="o-follow-up-question">
      <div className="o-follow-up-question__checkbox">
        <input
          id={`input-${rdn}`}
          className="o-follow-up-question__checkbox"
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={() => {
            setChecked(!checked);
            question.answer.checked = !checked;
            if (onAnswerChange) onAnswerChange();
          }}
        />
      </div>

      <div className="o-follow-up-question__label">
        <label htmlFor={`input-${rdn}`}>{question.title}</label>
      </div>

      <div className="o-follow-up-question__field">
        <DatePicker disabled={disabled || !checked} selected={value} onChange={(date) => {
          if (!date) {
            setValue(null);
            question.answer.value = null;
            if (onAnswerChange) onAnswerChange();
            return;
          }

          setValue(date);
          question.answer.value = moment(date).locale('en').format('YYYY-MM-DD');
          if (onAnswerChange) onAnswerChange();
        }} />
      </div>
    </div>
  )
}

FollowUpDateQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func,
}
